function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.4 9.00039C23.1 9.00039 23.7 8.40039 23.7 7.70039C23.7 7.00039 23.1 6.40039 22.4 6.40039C21.7 6.40039 21.1 7.00039 21.1 7.70039C21.2 8.50039 21.7 9.00039 22.4 9.00039Z",
  fill: "url(#paint4_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.4 12.8996L26.9 10.3996L26.8 10.2996C26.6 10.0996 26.3 10.0996 26 10.0996C25.3 10.0996 24.7 10.6996 24.7 11.3996C24.7 11.6996 24.8 11.9996 25 12.2996C25 12.2996 25 12.2996 25.1 12.3996L27.5 14.7996C27.7 14.9996 27.7 15.2996 27.5 15.5996C27.4 15.6996 27.3 15.7996 27.1 15.7996H25.8C25.1 15.7996 24.5 16.3996 24.5 17.0996V26.7996C24.5 27.3996 24.1 27.7996 23.5 27.7996H20.1V22.1996C20.1 20.1996 18.5 18.5996 16.5 18.5996H13.7C11.7 18.5996 10.1 20.1996 10.1 22.1996V27.7996H6.79998C6.19998 27.7996 5.79998 27.3996 5.79998 26.7996V16.9996C5.79998 16.2996 5.19998 15.6996 4.49998 15.6996H3.19998C3.09998 15.6996 2.89998 15.5996 2.79998 15.4996C2.69998 15.3996 2.59998 15.2996 2.59998 15.0996C2.59998 14.9996 2.69998 14.7996 2.79998 14.6996L14.8 2.69961C15 2.49961 15.4 2.49961 15.6 2.69961L17.8 4.99961C17.8 4.99961 17.8 4.99961 17.9 5.09961L18.1 5.29961C18.3 5.39961 18.5 5.49961 18.8 5.49961C19.5 5.49961 20.1 4.89961 20.1 4.19961C20.1 3.89961 20.1 3.69961 19.9 3.49961V3.39961L17.5 0.999609C16.3 -0.200391 14.2 -0.200391 13 0.999609L0.999976 12.9996C-0.200024 14.1996 -0.200024 16.1996 0.999976 17.4996C1.49998 17.9996 2.19998 18.2996 2.99998 18.2996H3.09998L3.19998 26.6996C3.19998 28.6996 4.79998 30.2996 6.79998 30.2996H11.5C12.2 30.2996 12.8 29.6996 12.8 28.9996V22.0996C12.8 21.4996 13.2 21.0996 13.8 21.0996H16.6C17.2 21.0996 17.6 21.4996 17.6 22.0996V28.9996C17.6 29.6996 18.2 30.2996 18.9 30.2996H23.6C25.6 30.2996 27.2 28.6996 27.2 26.6996V18.2996C28 18.2996 28.8 17.9996 29.4 17.3996C30.7 16.1996 30.7 14.1996 29.4 12.8996Z",
  fill: "url(#paint5_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 22.4,
  y1: 6.40039,
  x2: 22.4,
  y2: 9.00039,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 15.2375,
  y1: 0.0996094,
  x2: 15.2375,
  y2: 30.2996,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30.4,
  height: 30.3,
  fill: "white"
})));

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.404527cd.svg";
export { ForwardRef as ReactComponent };